module.exports = __webpack_public_path__ + "static/media/goalValue.271b5b1a.svg";